import { useMemo } from 'react';

export const useBusinessesWithResources = (resources) => {
  return useMemo(() => {
    if (!resources) {
      return new Set();
    }

    const businessIds = new Set();

    resources.forEach((resource) => {
      if (!businessIds.has(resource.BusinessId)) {
        businessIds.add(resource.BusinessId);
      }
    });

    return businessIds;
  }, [resources]);
};
